(function () {
  function getPostHog() {
    return window.posthog;
  }

  function capture(eventName, properties) {
    var ph = getPostHog();
    if (!ph || typeof ph.capture !== 'function') return;
    ph.capture(eventName, properties || {});
  }

  function readPageData() {
    var node = document.getElementById('posthog-page-data');
    if (!node) return {};
    try {
      return JSON.parse(node.textContent || '{}');
    } catch (error) {
      return {};
    }
  }

  function centsToMajor(cents) {
    var value = Number(cents);
    if (!value) return 0;
    return value / 100;
  }

  function whenPostHogReady(callback) {
    if (getPostHog() && typeof getPostHog().capture === 'function') {
      callback(getPostHog());
      return;
    }

    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;
      if (getPostHog() && typeof getPostHog().capture === 'function') {
        window.clearInterval(timer);
        callback(getPostHog());
      }
      if (attempts >= 60) {
        window.clearInterval(timer);
      }
    }, 100);
  }

  function trackPageEvents(data) {
    capture('Web Page Viewed', {
      page_type: data.pageType,
      template: data.template,
      path: data.path,
      url: data.url,
      currency: data.currency,
      locale: data.locale
    });

    if (data.product) {
      var product = data.product;
      capture('Product Viewed', {
        product_id: String(product.id),
        product_handle: product.handle,
        product_name: product.title,
        product_type: product.type,
        vendor: product.vendor,
        variant_id: String(product.variant_id),
        sku: product.sku,
        price: centsToMajor(product.price_cents),
        price_cents: product.price_cents,
        compare_at_price: centsToMajor(product.compare_at_price_cents),
        currency: data.currency,
        available: product.available,
        tags: product.tags
      });
    }

    if (data.collection) {
      capture('Collection Viewed', {
        collection_id: String(data.collection.id),
        collection_handle: data.collection.handle,
        collection_name: data.collection.title,
        product_count: data.collection.product_count
      });
    }

    if (data.search) {
      capture('Search Submitted', {
        search_query: data.search.terms,
        results_count: data.search.results_count
      });
    }

    if (data.cart) {
      capture('Cart Viewed', {
        item_count: data.cart.item_count,
        cart_total: centsToMajor(data.cart.total_price_cents),
        cart_total_cents: data.cart.total_price_cents,
        currency: data.currency
      });
    }
  }

  function productFromLink(anchor) {
    var href = anchor.getAttribute('href') || '';
    var match = href.match(/\/products\/([^/?#]+)/);
    if (!match) return null;
    return {
      product_handle: match[1],
      url: anchor.href
    };
  }

  function bindListeners() {
    document.addEventListener(
      'cart:update',
      function (event) {
        var detail = event.detail || {};
        var data = detail.data || {};
        if (data.didError) return;

        capture('Product Added to Cart', {
          product_id: data.productId ? String(data.productId) : undefined,
          variant_id: detail.sourceId ? String(detail.sourceId) : undefined,
          quantity: data.itemCount,
          source: data.source || 'theme'
        });
      },
      true
    );

    document.addEventListener(
      'variant:selected',
      function (event) {
        var resource = event.detail && event.detail.resource;
        if (!resource) return;
        capture('Product Variant Selected', {
          variant_id: String(resource.id),
          available: resource.available
        });
      },
      true
    );

    document.addEventListener(
      'click',
      function (event) {
        var target = event.target;
        if (!(target instanceof Element)) return;
        var anchor = target.closest('a[href*="/products/"]');
        if (!anchor) return;
        var product = productFromLink(anchor);
        if (!product) return;
        capture('Product Clicked', product);
      },
      true
    );
  }

  whenPostHogReady(function () {
    trackPageEvents(readPageData());
    bindListeners();
  });
})();
